export enum Schwangerschaftsmerkmal {
  _ = 0,
  S = 1,
  N = 2
}
